module.exports = __webpack_public_path__ + "static/media/modis2903.8d8b8acc.jpg";